export const getAbsoluteUrl = (url: string) => {
	if (!url.startsWith('http://') && !url.startsWith('https://')) {
		return `https://${url}`;
	}

	return url;
}